"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newsletterComponentGtm = exports.NewsletterComponentGtm = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var SignUpUtils_1 = require("Views/Partials/Components/SignUp/services/SignUpUtils");
var Forms_1 = require("Forms");
var NewsletterGtmFormConfig_1 = require("./NewsletterGtmFormConfig");
var formLoad_1 = require("./formLoad");
var NewsletterComponentGtm = /** @class */ (function (_super) {
    tslib_1.__extends(NewsletterComponentGtm, _super);
    function NewsletterComponentGtm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.newsletter-signup-gtm';
        _this.formWrapId = '#newsletter-form';
        _this.renderLoader = function (popupAriaLabel, closeButtonAriaLabel) {
            (0, formLoad_1.renderNewsletterLoader)(formLoad_1.renderComponent.NewsletterSpinner, _this.wrapper, null, 'newsletter-form group', popupAriaLabel, closeButtonAriaLabel);
        };
        _this.renderMessage = function (title, message, buttonLabel) {
            (0, formLoad_1.renderNewsletterLoader)(formLoad_1.renderComponent.NewsletterMessage(message, buttonLabel), _this.wrapper, title, 'newsletter-form newsletter-form--message group');
        };
        _this.getBusinessFields = function (formType) {
            var commonBusinessFields = {
                company: 'company',
                department: 'department',
                jobFunction: 'function',
            };
            var newsletterSpecificBusinessFields = {
                companyType: 'companyType',
            };
            var isNewsletterForm = formType === NewsletterGtmFormConfig_1.formTypes.newsletter;
            return tslib_1.__assign(tslib_1.__assign({}, commonBusinessFields), (isNewsletterForm && newsletterSpecificBusinessFields));
        };
        _this.getFormFields = function (formType) {
            var generalFields = {
                country: 'country',
                email: 'email',
                firstName: 'firstName',
                language: 'language',
                lastName: 'lastName',
            };
            return tslib_1.__assign(tslib_1.__assign({}, generalFields), _this.getBusinessFields(formType));
        };
        return _this;
    }
    NewsletterComponentGtm.prototype.OnInit = function () {
        var _this = this;
        this.wrapper = $(this.formWrapId).get(0);
        this.el.forEach(function (el) {
            _this.InitForm(el);
        });
    };
    NewsletterComponentGtm.prototype.convertData = function (formType, model, countries, languages) {
        return {
            consentText: model.specificFields.userConsentText,
            consentValidationMessage: model.specificFields.userConsentValidationMessage,
            chineseConsentText: model.specificFields.userChineseConsentText,
            chineseConsentValidationMessage: model.specificFields.userChineseConsentValidationMessage,
            countries: countries,
            numberOfEmployees: [],
            departments: (0, Forms_1.formatOptions)(model.departments, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            explanationText: model.specificFields.explanationText,
            functions: (0, Forms_1.formatOptions)(model.functions, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            genericFields: model.genericFields,
            inputs: SignUpUtils_1.signUpUtils.formatInputs(this.getFormFields(formType), model.genericFields, model.specificFields),
            languages: SignUpUtils_1.signUpUtils.formatLanguages(languages),
            specificFields: model.specificFields,
            submitLabel: model.genericFields.submitLabel,
            userTypes: model.userTypes,
            companyTypes: model.companyTypes && (0, Forms_1.formatOptions)(model.companyTypes, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
        };
    };
    NewsletterComponentGtm.prototype.InitForm = function (el) {
        var _this = this;
        var formType = app_1.AttrService.data(el, 'form-type');
        var apiUrl = app_1.AttrService.data(el, 'url');
        var pageId = app_1.AttrService.data(el, 'page');
        var control = app_1.AttrService.data(el, 'control');
        var locationApiUrl = app_1.AttrService.data(el, 'location-api-base-url');
        var locationApiKey = app_1.AttrService.data(el, 'location-api-key');
        var culture = app_1.AttrService.data(el, 'culture');
        var defaultErrorMsg = app_1.AttrService.data(el, 'error-message');
        var popupAriaLabel = app_1.AttrService.data(el, 'newsletter-aria-label');
        var closeButtonAriaLabel = app_1.AttrService.data(el, 'close-button-aria-label');
        var bypassRecaptchaKey = app_1.AttrService.data(el, 'bypass-recaptcha-key');
        var additionalFormData = {
            applications: app_1.AttrService.data(el, 'applications'),
            markets: app_1.AttrService.data(el, 'markets'),
            segments: app_1.AttrService.data(el, 'segments'),
            solutions: app_1.AttrService.data(el, 'solutions'),
            subSegments: app_1.AttrService.data(el, 'subSegments'),
            popUpHeadline: app_1.AttrService.data(el, 'pop-up-headline'),
            popUpBulletTop: app_1.AttrService.data(el, 'pop-up-bullet-top'),
            popUpBulletMiddle: app_1.AttrService.data(el, 'pop-up-bullet-middle'),
            popUpBulletBottom: app_1.AttrService.data(el, 'pop-up-bullet-bottom'),
        };
        var countryService = SignUpUtils_1.signUpUtils.createCountryService(locationApiUrl, culture, locationApiKey);
        // Open modal && show preloader
        var showNewsletterPopup = function () {
            _this.renderLoader(popupAriaLabel, closeButtonAriaLabel);
            var formDataPromise = SignUpUtils_1.signUpUtils.getFormData(apiUrl, { pageId: pageId });
            var countryPromise = countryService.getDataForSelectOptions();
            var buttonLabel = 'buttonLabel';
            var labelsAndPageId = {
                buttonLabel: buttonLabel,
                pageId: pageId,
                popupAriaLabel: popupAriaLabel,
                closeButtonAriaLabel: closeButtonAriaLabel,
            };
            Promise.all([formDataPromise, countryPromise])
                .then(function (_a) {
                var formData = _a[0], countries = _a[1];
                var languages = SignUpUtils_1.signUpUtils.convertLanguages(formData.languages);
                var formItems = _this.convertData(formType, formData, countries, languages);
                var reCaptchaSiteKey = formData.reCaptchaSiteKey;
                // Remove explanationText
                delete formItems.explanationText;
                _this.renderForm(formType, formData, formItems, additionalFormData, reCaptchaSiteKey, control, labelsAndPageId, bypassRecaptchaKey);
            })
                .catch(function (err) {
                _this.renderMessage(null, err.response.data.message || defaultErrorMsg);
            });
        };
        window['showNewsletterPopup'] = showNewsletterPopup;
    };
    NewsletterComponentGtm.prototype.renderForm = function (formType, formData, formItems, additionalFormData, reCaptchaSiteKey, control, labelsAndPageId, bypassRecaptchaKey) {
        var _this = this;
        var title = formData.specificFields && formData.specificFields.titleText
            ? formData.specificFields.titleText
            : null;
        var inputObject = this.getInputObject(formItems);
        var gtmData = {
            label: labelsAndPageId.buttonLabel,
            title: title,
            control: control,
        };
        app_1.GTM.newsletter.open(gtmData);
        var onModelClose = function () {
            app_1.GTM.newsletter.abandon(gtmData);
        };
        if (formData.culture) {
            additionalFormData.culture = formData.culture;
        }
        var renderSpinner = function () {
            _this.renderLoader(labelsAndPageId.popupAriaLabel, labelsAndPageId.closeButtonAriaLabel);
        };
        var signUpTypes = {
            formType: formType,
            formItems: formItems,
            inputObject: inputObject,
        };
        var hashMapTypes = {
            additionalFormData: additionalFormData,
            businessFields: this.getBusinessFields(formType),
            formFields: this.getFormFields(formType),
        };
        var render = {
            renderSpinner: renderSpinner,
            renderMessage: this.renderMessage,
        };
        // render form instead loader
        (0, formLoad_1.renderNewsletterLoader)(formLoad_1.renderComponent.Form(signUpTypes, formData.postUrl, hashMapTypes, reCaptchaSiteKey, bypassRecaptchaKey, render, control, labelsAndPageId.pageId), this.wrapper, additionalFormData.popUpHeadline, NewsletterGtmFormConfig_1.newsletterGtmConfig.newsletterClass, labelsAndPageId.popupAriaLabel, labelsAndPageId.closeButtonAriaLabel, onModelClose);
    };
    NewsletterComponentGtm.prototype.getInputObject = function (formItems) {
        var inputs = formItems.inputs, countries = formItems.countries, functions = formItems.functions, departments = formItems.departments, companyTypes = formItems.companyTypes, genericFields = formItems.genericFields, specificFields = formItems.specificFields, languages = formItems.languages, userTypes = formItems.userTypes;
        var inputObject = inputs.reduce(function (acc, currentValue) {
            acc[currentValue.name] = currentValue;
            return acc;
        }, {});
        inputObject.country.options = countries;
        inputObject.jobFunction.options = functions;
        inputObject.department.options = departments;
        inputObject.companyType && (inputObject.companyType.options = companyTypes);
        inputObject.language.languages = languages;
        inputObject.userTypes = userTypes;
        inputObject.genericFields = genericFields;
        inputObject.specificFields = specificFields;
        return inputObject;
    };
    return NewsletterComponentGtm;
}(app_1.Component));
exports.NewsletterComponentGtm = NewsletterComponentGtm;
exports.newsletterComponentGtm = new NewsletterComponentGtm();
